import { OptionItem, PropInfo, Section, SectionType, TextBoxOption } from "./TextSection"

export class SectionBase implements Section {
    row: number
    col: number
    height: number
    width: number
    name: string
    id: string
    selected: boolean
    type: SectionType
    x?: number
    y?: number
    rowCount: number
    colCount: number
    options?: OptionItem[] | TextBoxOption[]
    value?: any
    propInfo?: PropInfo[] | undefined
    textContent: string
    rotation: number = 0
    isLocked: boolean = false
    constructor(
      options:Section
    ) {
      this.row = options.row
      this.col = options.col
      this.height = options.height
      this.width = options.width
      this.name = options.name
      this.type = options.type
      this.id = options.id
      this.x = options.x
      this.y = options.y
      this.selected = options.selected
      this.rowCount = options.rowCount
      this.colCount = options.colCount
      this.propInfo = options.propInfo
      this.textContent = options.textContent
    }
    clone() {
      return new SectionBase(this.toJSON())
    }
    render(): HTMLDivElement {
      const wrapper = document.createElement('div');
      wrapper.classList.add('wrapper');
      wrapper.style.transform = `rotate(${this.rotation}deg)`;
      
      const section = document.createElement('div');
      section.classList.add('section');
      section.style.transform = `rotate(${this.rotation}deg)`;
      
      this.addRotateControl(wrapper);
      wrapper.appendChild(section);
      
      return wrapper;
    }
    setupEvents(){

    }
  
    toJSON(): Section {
      return {
        row: this.row,
        col: this.col,
        height: this.height,
        width: this.width,
        name: this.name,
        type: this.type,
        textContent: this.textContent,
        id: this.id,
        selected: this.selected,
        rowCount: this.rowCount,
        colCount: this.colCount,
        options:this.options || [],
        value:this.value,
        x: this.x ? this.x : -1,
        y: this.y ? this.y : -1,
        propInfo: JSON.parse(JSON.stringify(this.propInfo)),
        isLocked: this.isLocked
      }
    }
    protected addRotateControl(parent: HTMLElement): void {
      const rotateIcon = document.createElement('span');
      rotateIcon.innerHTML = '🔄';
      rotateIcon.className = 'rotate-control';
      rotateIcon.title = 'Rotate';
      Object.assign(rotateIcon.style, {
        position: 'absolute',
        bottom: '-12px',
        left: '50%',
        transform: 'translateX(-50%)',
        cursor: 'pointer',
        zIndex: '1000',
        backgroundColor: '#fff',
        border: '1px solid #000',
        borderRadius: '50%',
        padding: '2px',
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px'
      });
      
      parent.appendChild(rotateIcon);
    }
  }